(()=>{
  const RUNTIME_KEY='__aeeyaaSizeGuideRuntime';
  if(window[RUNTIME_KEY]){ window[RUNTIME_KEY].initAll(); return; }

  const SELECTOR='[data-aeeyaa-size-helper-host]';
  const RANGE_TOLERANCE_CM=0.15;
  const stateStore=window.__aeeyaaSizeGuideState||(window.__aeeyaaSizeGuideState=new Map());

  function parseMap(rows){
    const out={};
    (rows||[]).forEach(row=>{
      const parts=String(row).split('|');
      const key=parts.shift();
      out[key]={};
      parts.forEach(part=>{ const i=part.indexOf(':'); if(i>-1) out[key][part.slice(0,i)]=part.slice(i+1); });
    });
    return out;
  }

  function parseMeasurement(rows){
    return (rows||[]).map(row=>{
      const parts=String(row).split('|');
      const range=parts.shift().split('-').map(Number);
      return {
        min:range[0], max:range[1],
        rules:parts.map(part=>{
          const i=part.indexOf(':');
          const r=part.slice(0,i).split('-').map(Number);
          return {min:r[0],max:r[1],size:part.slice(i+1)};
        })
      };
    });
  }

  function parseInternational(rows){
    return (rows||[]).map(row=>{
      const parts=String(row).split('|');
      const base=parts.shift();
      const obj={US:base};
      parts.forEach(part=>{ const i=part.indexOf(':'); if(i>-1) obj[part.slice(0,i)]=part.slice(i+1); });
      return obj;
    });
  }

  function cleanRecommendation(raw){
    if(!raw||raw==='-') return null;
    const edge=raw.endsWith('*');
    return {size:edge?raw.slice(0,-1):raw,edge};
  }

  function formatRange(min,max,unit){
    if(unit==='cm') return min+'–'+max+' cm';
    return (min/2.54).toFixed(1)+'–'+(max/2.54).toFixed(1)+' in';
  }

  function renderBraChart(tbody,bands,cups,map){
    if(!tbody) return;
    tbody.innerHTML='';
    (bands||[]).forEach(band=>{
      const tr=document.createElement('tr');
      const th=document.createElement('th'); th.scope='row'; th.textContent=band; tr.appendChild(th);
      (cups||[]).forEach(cup=>{
        const td=document.createElement('td');
        const raw=map[band]&&map[band][cup]?map[band][cup]:'-';
        if(raw==='-'){ td.textContent='—'; td.classList.add('is-no-match'); }
        else { td.textContent=raw; if(raw.endsWith('*')) td.classList.add('is-edge'); }
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    });
  }

  function renderInternational(tbody,rows){
    if(!tbody) return;
    tbody.innerHTML='';
    rows.forEach(r=>{
      const tr=document.createElement('tr');
      ['US','UK','EU','JP','AUSNZ'].forEach(k=>{ const td=document.createElement('td'); td.textContent=r[k]||'—'; tr.appendChild(td); });
      tbody.appendChild(tr);
    });
  }

  function renderMeasurementChart(thead,tbody,rows,unit){
    if(!thead||!tbody||!rows.length) return;
    const headRow=document.createElement('tr');
    const corner=document.createElement('th'); corner.textContent='Full Bust − Underbust'; headRow.appendChild(corner);
    rows.forEach(row=>{ const th=document.createElement('th'); th.textContent=formatRange(row.min,row.max,unit); headRow.appendChild(th); });
    thead.innerHTML=''; thead.appendChild(headRow);

    tbody.innerHTML='';
    const rules=rows[0].rules||[];
    rules.forEach((rule,idx)=>{
      const tr=document.createElement('tr');
      const th=document.createElement('th'); th.scope='row'; th.textContent=formatRange(rule.min,rule.max,unit); tr.appendChild(th);
      rows.forEach(row=>{
        const td=document.createElement('td');
        const r=row.rules[idx]; const raw=r?r.size:'-';
        td.textContent=raw&&raw!=='-'?raw:'—';
        if(!raw||raw==='-') td.classList.add('is-no-match');
        if(raw&&raw.endsWith('*')) td.classList.add('is-edge');
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    });
  }

  function getState(host){
    const key=(host.dataset.productId||'product')+':'+(host.dataset.sectionId||'section');
    if(!stateStore.has(key)) stateStore.set(key,{band:'',cup:'',unit:'in'});
    return stateStore.get(key);
  }

  function init(host){
    if(!host||host.dataset.aeeyaaInitialized==='true') return;
    let data;
    try{ data=JSON.parse(host.querySelector('[data-aeeyaa-size-data]').textContent); }catch(e){ return; }

    const info=host.closest('.hdt-product-info__list')||document;
    const sourceQuick=host.querySelector(':scope > [data-aeeyaa-size-quick]');
    const sourceTrigger=host.querySelector(':scope > [data-aeeyaa-size-guide-trigger]');
    const dialog=host.querySelector('[data-aeeyaa-size-dialog]');
    const close=host.querySelector('[data-aeeyaa-size-close]');
    if(!sourceQuick||!sourceTrigger) return;

    const state=getState(host);
    sourceQuick.hidden=true; sourceTrigger.hidden=true; host.dataset.aeeyaaInitialized='true';

    const braMap=parseMap(data.braMap);
    const measurementMap=parseMeasurement(data.measurementMap);
    const internationalBands=parseInternational(data.internationalBands);
    const internationalCups=parseInternational(data.internationalCups);
    const underMin=measurementMap.length?Math.min(...measurementMap.map(r=>r.min)):null;
    const underMax=measurementMap.length?Math.max(...measurementMap.map(r=>r.max)):null;
    let mountPending=false, mountRetries=0;

    function getPicker(){ return info.querySelector('hdt-variant-picker'); }
    function getSizeField(picker){
      if(!picker) return null;
      return picker.querySelector('fieldset.is-style-size')||[...picker.querySelectorAll('fieldset')].find(fs=>{
        const l=fs.querySelector('legend'); return l&&/^size\b/i.test(l.textContent.trim());
      })||null;
    }
    function getForm(){ const picker=getPicker(); const formId=picker&&picker.getAttribute('form'); return formId?document.forms[formId]:null; }

    function renameSizeLegend(sizeField){
      const legend=sizeField&&sizeField.querySelector('legend');
      if(!legend) return null;
      const label=legend.querySelector(':scope > span');
      if(label){
        const textNode=[...label.childNodes].find(n=>n.nodeType===Node.TEXT_NODE);
        if(textNode) textNode.nodeValue='Select Your Size';
        const update=label.querySelector('[update-value]'); if(update) update.setAttribute('aria-hidden','true');
      }
      return legend;
    }

    function findSizeInput(size){
      const sizeField=getSizeField(getPicker()); if(!sizeField) return null;
      const target=String(size).trim().toLowerCase();
      return [...sizeField.querySelectorAll('input[type="radio"],input[is-value],button[role="option"]')]
        .find(el=>String(el.value||el.getAttribute('value')||'').trim().toLowerCase()===target)||null;
    }

    function getSizeStatus(size){
      const el=findSizeInput(size);
      if(!el) return {exists:false,available:false,el:null};
      const unavailable=el.disabled||el.classList.contains('is-unavailable')||el.classList.contains('is-disabled');
      return {exists:true,available:!unavailable,el};
    }

    function selectActualSize(size){
      const status=getSizeStatus(size);
      if(!status.exists||!status.available) return status;
      const el=status.el;
      if(el.tagName==='INPUT'){ if(!el.checked) el.click(); }
      else el.click();
      return status;
    }

    function recommendationHtml(rec){
      if(!rec) return '<span>No confident match — check Size Guide</span>';
      const status=getSizeStatus(rec.size);
      if(!status.exists) return '<span>Recommended AeeYaa Size:</span> <strong>'+rec.size+'</strong><span> — not available for this style.</span>';
      if(!status.available) return '<span>Recommended AeeYaa Size:</span> <strong>'+rec.size+'</strong><span> — currently unavailable in this color.</span>';
      return '<span>Recommended AeeYaa Size:</span> <strong>'+rec.size+'</strong>';
    }

    function computeRecommendation(){
      if(!state.band||!state.cup) return null;
      return cleanRecommendation(braMap[state.band]?braMap[state.band][state.cup]:null);
    }

    function paintQuick(quick){
      if(!quick) return;
      const band=quick.querySelector('[data-aeeyaa-band]');
      const cup=quick.querySelector('[data-aeeyaa-cup]');
      const result=quick.querySelector('[data-aeeyaa-result]');
      const edge=quick.querySelector('[data-aeeyaa-edge-note]');
      if(band) band.value=state.band; if(cup) cup.value=state.cup;
      if(!state.band||!state.cup){ if(result) result.hidden=true; if(edge) edge.hidden=true; return; }
      const rec=computeRecommendation();
      if(result){ result.hidden=false; result.innerHTML=recommendationHtml(rec); }
      if(edge){
        const note=rec&&rec.edge?(data.edgeNote||'Check your measurements for the best fit.'):'';
        edge.textContent=note; edge.hidden=!note;
      }
    }

    function bindQuick(quick){
      if(!quick||quick.dataset.aeeyaaWired==='true') return;
      quick.dataset.aeeyaaWired='true';
      const band=quick.querySelector('[data-aeeyaa-band]'); const cup=quick.querySelector('[data-aeeyaa-cup]');
      const handleChange=()=>{
        state.band=band?band.value:''; state.cup=cup?cup.value:'';
        const rec=computeRecommendation();
        if(rec) selectActualSize(rec.size);
        paintQuick(quick);
      };
      if(band) band.addEventListener('change',handleChange); if(cup) cup.addEventListener('change',handleChange);
    }

    function bindTrigger(trigger){
      if(!trigger||trigger.dataset.aeeyaaWired==='true') return;
      trigger.dataset.aeeyaaWired='true';
      trigger.addEventListener('click',()=>{ if(!dialog) return; if(typeof dialog.showModal==='function') dialog.showModal(); else dialog.setAttribute('open',''); });
    }

    function mountIntoPicker(){
      const picker=getPicker(); const sizeField=getSizeField(picker); if(!picker||!sizeField) return false;
      sizeField.classList.add('aeeyaa-size-enabled');
      let mountedQuick=picker.querySelector('[data-aeeyaa-size-quick-mounted]');
      if(!mountedQuick){
        mountedQuick=sourceQuick.cloneNode(true); mountedQuick.hidden=false; mountedQuick.setAttribute('data-aeeyaa-size-quick-mounted','');
        picker.insertBefore(mountedQuick,sizeField);
      }
      bindQuick(mountedQuick); paintQuick(mountedQuick);
      const legend=renameSizeLegend(sizeField);
      if(legend){
        [...legend.children].forEach(child=>{ if(child.tagName==='BUTTON'||child.tagName==='WRAPP-OPEN-PSWP-BTN') child.style.display='none'; });
        let mountedTrigger=legend.querySelector('[data-aeeyaa-size-guide-trigger-mounted]');
        if(!mountedTrigger){
          mountedTrigger=sourceTrigger.cloneNode(true); mountedTrigger.hidden=false; mountedTrigger.style.display='';
          mountedTrigger.setAttribute('data-aeeyaa-size-guide-trigger-mounted',''); legend.appendChild(mountedTrigger);
        }
        bindTrigger(mountedTrigger);
      }
      mountRetries=0; return true;
    }

    function scheduleMount(){
      if(mountPending) return; mountPending=true;
      requestAnimationFrame(()=>{
        mountPending=false;
        if(!mountIntoPicker()&&mountRetries<8){ mountRetries+=1; setTimeout(scheduleMount,60); }
      });
    }

    if(close&&dialog) close.addEventListener('click',()=>dialog.close());
    if(dialog) dialog.addEventListener('click',e=>{ if(e.target===dialog) dialog.close(); });

    renderBraChart(host.querySelector('[data-aeeyaa-bra-chart]'),data.bands,data.cups,braMap);
    renderInternational(host.querySelector('[data-aeeyaa-int-band]'),internationalBands);
    renderInternational(host.querySelector('[data-aeeyaa-int-cup]'),internationalCups);

    const tabButtons=[...host.querySelectorAll('[data-aeeyaa-tab]')];
    const panels=[...host.querySelectorAll('[data-aeeyaa-panel]')];
    tabButtons.forEach(btn=>btn.addEventListener('click',()=>{
      const key=btn.dataset.aeeyaaTab;
      tabButtons.forEach(b=>{ const active=b===btn; b.classList.toggle('is-active',active); b.setAttribute('aria-selected',active?'true':'false'); });
      panels.forEach(p=>{ const active=p.dataset.aeeyaaPanel===key; p.classList.toggle('is-active',active); p.hidden=!active; });
    }));

    const unitBtns=[...host.querySelectorAll('[data-aeeyaa-unit]')];
    const under=host.querySelector('[data-aeeyaa-underbust]'); const bust=host.querySelector('[data-aeeyaa-fullbust]');
    const measureResult=host.querySelector('[data-aeeyaa-measure-result]');
    const measureHead=host.querySelector('[data-aeeyaa-measure-head]'); const measureBody=host.querySelector('[data-aeeyaa-measure-body]');
    let unit=state.unit||'in';

    function clampEdge(value,min,max){
      if(value<min&&value>=min-RANGE_TOLERANCE_CM) return min;
      if(value>max&&value<=max+RANGE_TOLERANCE_CM) return max;
      return value;
    }

    function findMeasurementRow(underCm){
      if(!measurementMap.length) return null;
      const adjusted=clampEdge(underCm,underMin,underMax);
      for(let i=0;i<measurementMap.length;i++){
        const r=measurementMap[i]; const last=i===measurementMap.length-1;
        if(adjusted>=r.min&&(adjusted<r.max||(last&&adjusted<=r.max))) return r;
      }
      return null;
    }

    function findContinuousRule(row,diff){
      const rules=(row&&row.rules?row.rules:[]).slice().sort((a,b)=>a.min-b.min);
      for(let i=0;i<rules.length;i++){
        const rule=rules[i]; const prev=rules[i-1]; const next=rules[i+1];
        const lower=i===0?rule.min-0.5:(prev.max+rule.min)/2;
        const upper=i===rules.length-1?rule.max+0.5:(rule.max+next.min)/2;
        const matches=diff>=lower&&(i===rules.length-1?diff<=upper:diff<upper);
        if(matches) return rule;
      }
      return null;
    }

    function measurementOutcome(underCm,bustCm){
      if(!Number.isFinite(underCm)||!Number.isFinite(bustCm)) return {status:'incomplete'};
      if(bustCm<=underCm) return {status:'invalid-order'};
      if(!measurementMap.length||underMin===null||underMax===null) return {status:'unsupported-fit'};
      const adjustedUnder=clampEdge(underCm,underMin,underMax);
      if(adjustedUnder<underMin||adjustedUnder>underMax) return {status:'under-out'};
      const row=findMeasurementRow(adjustedUnder); if(!row) return {status:'under-out'};
      const diff=bustCm-underCm;
      const rule=findContinuousRule(row,diff);
      if(!rule) return {status:'unsupported-fit'};
      const rec=cleanRecommendation(rule.size);
      if(!rec) return {status:'unsupported-fit'};
      return {status:'ok',rec};
    }

    function underRangeMessage(){
      if(unit==='cm') return 'Your underbust is outside this style’s supported range: '+underMin+'–'+underMax+' cm ('+(underMin/2.54).toFixed(1)+'–'+(underMax/2.54).toFixed(1)+' in).';
      return 'Your underbust is outside this style’s supported range: '+(underMin/2.54).toFixed(1)+'–'+(underMax/2.54).toFixed(1)+' in ('+underMin+'–'+underMax+' cm).';
    }

    function setMeasureResult(kind,html){
      if(!measureResult) return;
      measureResult.classList.remove('is-error','is-warning','is-success');
      if(!html){ measureResult.hidden=true; measureResult.innerHTML=''; return; }
      measureResult.hidden=false; measureResult.classList.add(kind); measureResult.innerHTML=html;
    }

    function calculateMeasurement(){
      if(!under||!bust||!measureResult) return;
      const u=parseFloat(under.value); const b=parseFloat(bust.value);
      under.removeAttribute('aria-invalid'); bust.removeAttribute('aria-invalid');
      if(!Number.isFinite(u)||!Number.isFinite(b)){ setMeasureResult('', ''); return; }
      const underCm=unit==='in'?u*2.54:u; const bustCm=unit==='in'?b*2.54:b;
      const outcome=measurementOutcome(underCm,bustCm);
      if(outcome.status==='invalid-order'){
        under.setAttribute('aria-invalid','true'); bust.setAttribute('aria-invalid','true');
        setMeasureResult('is-error','Please check your measurements. Full Bust should be larger than Underbust.'); return;
      }
      if(outcome.status==='under-out'){
        under.setAttribute('aria-invalid','true'); setMeasureResult('is-warning',underRangeMessage()); return;
      }
      if(outcome.status!=='ok'){
        setMeasureResult('is-warning','These measurements fall outside this style’s supported fit range, so we can’t recommend a size confidently.'); return;
      }
      const rec=outcome.rec; const sizeStatus=getSizeStatus(rec.size);
      if(!sizeStatus.exists){
        setMeasureResult('is-warning','Recommended AeeYaa Size: <strong>'+rec.size+'</strong> — not available for this style.'); return;
      }
      if(!sizeStatus.available){
        setMeasureResult('is-warning','Recommended AeeYaa Size: <strong>'+rec.size+'</strong> — currently unavailable in this color.'); return;
      }
      setMeasureResult('is-success','Recommended AeeYaa Size: <strong>'+rec.size+'</strong>');
      selectActualSize(rec.size);
    }

    function updateMeasurementInputs(){
      if(under){
        under.placeholder=unit==='in'?'e.g. 29.0':'e.g. 74';
        if(underMin!==null&&underMax!==null){
          under.min=unit==='in'?(underMin/2.54).toFixed(1):String(underMin);
          under.max=unit==='in'?(underMax/2.54).toFixed(1):String(underMax);
        }
      }
      if(bust) bust.placeholder=unit==='in'?'e.g. 34.0':'e.g. 86';
    }

    function setUnit(next){
      if(next===unit) return;
      [under,bust].forEach(el=>{
        if(!el) return;
        const v=parseFloat(el.value); if(!Number.isFinite(v)) return;
        el.value=unit==='in'&&next==='cm'?(v*2.54).toFixed(1):(v/2.54).toFixed(1);
      });
      unit=next; state.unit=next;
      unitBtns.forEach(b=>b.classList.toggle('is-active',b.dataset.aeeyaaUnit===unit));
      updateMeasurementInputs(); renderMeasurementChart(measureHead,measureBody,measurementMap,unit); calculateMeasurement();
    }

    unitBtns.forEach(b=>b.addEventListener('click',()=>setUnit(b.dataset.aeeyaaUnit)));
    [under,bust].forEach(el=>{ if(el) el.addEventListener('input',calculateMeasurement); });
    unitBtns.forEach(b=>b.classList.toggle('is-active',b.dataset.aeeyaaUnit===unit));
    updateMeasurementInputs(); renderMeasurementChart(measureHead,measureBody,measurementMap,unit);

    const form=getForm(); if(form) form.addEventListener('variant:change',scheduleMount);
    scheduleMount();
  }

  function initAll(root=document){
    const candidates=[];
    if(root.matches&&root.matches(SELECTOR)) candidates.push(root);
    if(root.querySelectorAll) candidates.push(...root.querySelectorAll(SELECTOR));
    candidates.forEach(init);
  }

  const runtime={initAll}; window[RUNTIME_KEY]=runtime;
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>initAll(),{once:true}); else initAll();
  document.addEventListener('shopify:section:load',e=>initAll(e.target));
})();
